var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2C8.17825 2 2 7.4448 2 14.1632C2 20.88 7.6875 28.4 15 34C22.3125 28.4 28 20.88 28 14.1632C28 7.4448 21.8234 2 15 2ZM15 19.6C12.3074 19.6 10.125 17.4512 10.125 14.8C10.125 12.1488 12.3074 10 15 10C17.6926 10 19.875 12.1488 19.875 14.8C19.875 17.4512 17.6926 19.6 15 19.6Z",
    stroke: "#BA71AE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.af2c01ffb154be27e1c1fc9777a1287d.svg";
export { ForwardRef as ReactComponent };